<template>
  <div class="calendar-options-config-dialog">
    <el-collapse v-model="activeNames" class="relative-setting-box">
      <el-collapse-item name="2" v-if="styleId === 2">
        <template slot="title">
          <span>活动弹窗设置</span>
          <el-tooltip class="item" effect="dark" content="固定显示主题和时间字段 时间只显示几时几分" placement="top">
            <i class="tips-btn icon-portal-info2"></i>
          </el-tooltip>
        </template>
        <div class="content-item mb16">
          <cx-check-box :value.sync="activityTooltip">开启活动弹窗</cx-check-box>
        </div>
        <div v-if="activityTooltip">
          <div class="content-item mb16">
            <slider-and-input :value.sync="activityTooltipWidth" title="弹窗宽度" :sliderMax="400" suffix="px" />
          </div>
          <div class="content-item mb16">
            <slider-and-input :value.sync="activityTooltipHeight" title="弹窗高度" :sliderMax="400" suffix="px" />
          </div>
          <div class="content-item mb16">
            <slider-and-input :value.sync="activityLineHeight" title="单行高度" :sliderMax="100" suffix="px" />
          </div>
          <div class="content-item mb16">
            <p class="font14 mb16 mt16">标题文字样式</p>
            <text-setting-update
              :fontColor.sync="tooltipTitleColor"
              :fontFamily.sync="tooltipTitleFontFamily"
              :fontSize.sync="tooltipTitleFontSize"
              :fontWeight.sync="tooltipTitleFontWeight"
            />
          </div>
          <div class="content-item verticallyCenter">
            <el-checkbox v-model="contentHasLimit">字数限制</el-checkbox>
          </div>
          <div v-show="contentHasLimit" class="content-item card mt16">
            <div class="content-item fs14 verticallyCenter count-limit-item">
              <span class="mr16">超出</span>
              <single-input
                class="size-inp mr8"
                style="width: 90px; height: 32px"
                :value.sync="textLimitLines"
                inputSuffixs="字"
              />
              <span>隐藏</span>
            </div>
          </div>
          <div class="content-item mb16">
            <p class="font14 mb16 mt16">时间文字样式</p>
            <text-setting-update
              :fontColor.sync="tooltipTimeColor"
              :fontFamily.sync="tooltipTimeFontFamily"
              :fontSize.sync="tooltipTimeFontSize"
              :fontWeight.sync="tooltipTimeFontWeight"
            />
          </div>
          <div class="content-item mb16" style="display: none">
            <slider-and-input :value.sync="activityTooltipSpace" title="间距" :sliderMax="50" suffix="px" />
          </div>
          <div class="content-item mb16">
            <div class="verticallyCenter">
              <span class="fs14 mr16">背景</span>
              <cx-color-picker
                class="custom-title-color flex1"
                :isThemeColor.sync="activityTooltipBgIsThemeColor"
                :colorArr.sync="activityTooltipBgColor"
              ></cx-color-picker>
            </div>
          </div>
          <div class="content-item mb16">
            <border-radius
              :borderTypeFlag.sync="tooltipBorderTypeFlag"
              :borderRadius.sync="tooltipBorderRadius"
              :borderTopLeftRadius.sync="tooltipBorderTopLeftRadius"
              :borderTopRightRadius.sync="tooltipBorderTopRightRadius"
              :borderBottomRightRadius.sync="tooltipBorderBottomRightRadius"
              :borderBottomLeftRadius.sync="tooltipBorderBottomLeftRadius"
              :sliderMax="100"
            />
          </div>
          <div class="content-item mb16">
            <div class="checkbox_colorPicker_container">
              <label>边框</label>
            </div>
            <div class="verticallyCenter">
              <cx-border
                :borderWidth.sync="tooltipBorderWidth"
                :borderStyle.sync="tooltipBorderStyle"
                :borderColor.sync="tooltipBorderColor"
                :borderIsThemeColor.sync="tooltipBorderIsThemeColor"
              />
            </div>
          </div>
          <div class="content-item mb16">
            <cx-padding
              :paddingTypeFlag.sync="tooltipPaddingTypeFlag"
              :padding.sync="tooltipPadding"
              :paddingTop.sync="tooltipPaddingTop"
              :paddingRight.sync="tooltipPaddingRight"
              :paddingBottom.sync="tooltipPaddingBottom"
              :paddingLeft.sync="tooltipPaddingLeft"
              :sliderMax="100"
            />
          </div>
          <div class="content-item mt16">
            <div class="checkbox_colorPicker_container">
              <span>阴影</span>
              <span class="icon-portal-plus theme-color right-icon" @click="addBoxshadow"></span>
            </div>
            <box-shadow
              :boxShadowH.sync="tooltipBoxShadowH"
              :boxShadowV.sync="tooltipBoxShadowV"
              :boxShadowBlur.sync="tooltipBoxShadowBlur"
              :boxShadowSpread.sync="tooltipBoxShadowSpread"
              :boxShadowColor.sync="tooltipBoxShadowColor"
            ></box-shadow>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item name="1" v-if="(styleId === 1 || styleId === 3) && showResponsePlugin">
        <template slot="title">
          <span>联动设置</span>
          <el-tooltip class="item" effect="dark" content="仅支持联动同一通栏下的组件" placement="top">
            <i class="tips-btn icon-portal-info2"></i>
          </el-tooltip>
        </template>
        <div v-if="(styleId === 1 || styleId === 3) && hasRelativePlugin">
          <div class="verticallyCenter mt12 mb16 setting-item type-change-item">
            <span class="mr16">切换方式</span>
            <el-radio v-model="relativeType" label="click">点击</el-radio>
            <el-radio v-model="relativeType" label="hover">悬停</el-radio>
          </div>
          <div class="setting-item">
            <cx-select
              title="联动组件"
              :selectOptions="relativeComponentLists"
              :value.sync="relativeComponentId"
              @change="changeRelativeName"
            />
          </div>
          <div class="setting-item mt16" v-if="relativeComponentId">
            <p class="">时间段设置</p>
            <div class="select_flag_div mt16">
              <div class="setting-item mt16">
                <cx-select title="开始日期" :selectOptions="flagLists" :value.sync="startDateFlag" />
              </div>
              <div class="setting-item mt16">
                <cx-select title="结束日期" :selectOptions="flagLists" :value.sync="endDateFlag" />
              </div>
            </div>
          </div>
        </div>
        <p v-else>添加了联动插件后可实现联动设置</p>
      </el-collapse-item>
      <el-collapse-item name="3" v-if="styleId === 2">
        <template slot="title">
          <span>高级设置</span>
        </template>
        <div>
          <div class="content-item">
            <el-checkbox v-model="deliverMhParams">携带系统参数</el-checkbox>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item name="4" v-if="(styleId === 1 || styleId === 3) && pageType === 'listPage'">
        <template slot="title">
          <span>{{ hasRelativePlugin ? '列表页' : '' }}联动设置</span>
        </template>
        <div>
          <div class="setting-item mt16">
            <p class="">时间段设置</p>
            <div class="select_flag_div mt16">
              <div class="setting-item mt16">
                <cx-select title="开始日期" :selectOptions="filterFlagLists" :value.sync="filterStartDateFlag" />
              </div>
              <div class="setting-item mt16">
                <cx-select title="结束日期" :selectOptions="filterFlagLists" :value.sync="filterEndDateFlag" />
              </div>
            </div>
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import { findCurrentComponentPathInLayoutByRectId, findAllRects, getAllRectInNewLayout } from "utils"
import { UpdateLayoutData } from "utils/updateData/layout/layoutComponentUpdateData.js"
import { getAppointCacheData } from "utils/updateData/publicDataUtils/getRestClassify.js"
import { withMethodsHistoryCombine } from "utils/revork"
export default withMethodsHistoryCombine({
  name: "calendar-options-config",
  components: {},
  props: { options: Object },
  data() {
    return {
      activeNames: ["2", "4"],
      relativeComponentLists: [], //关联组件的列表
      flagLists: [],
      hasRelativePlugin: false,
      this1: this,
      filterFlagLists: []
    }
  },
  comments: {},
  mounted() {
    this.getRelativeLists()
    if (Array.isArray(this.options?.pluginName) && this.options?.pluginName.length > 0) {
      this.options.pluginName.forEach(item => {
        if (item.indexOf("calendarResponseDataPlugin") !== -1) this.hasRelativePlugin = true
      })
    }
    this.getPublicId()
    if (this.$store.state[this.request_prefix].page.pluginName?.includes("listPagePlugin")) {
      const rectAttr = this.findComponent('emptyLayoutComponent')
      this.getFields(rectAttr)
    }
    if (this.$store.state[this.request_prefix].page.pluginName?.includes("subPagePlugin")) {
      this.getFieldsNew()
    }
  },
  watch:{
    deliverMhParams: {
      handler: function (val) {
        this.highSet()
      },
      deep: false
    }
  },
  computed: {
    showResponsePlugin() {
      if (this.pageType === "listPage") return this.hasRelativePlugin
      return true
    },
    pageType() {
      return this.$store.state[this.request_prefix].type
    },
    ids() {
      return this.$store.state.states.activeID
    },
    styleId() {
      return this.options.styleId
    },
    deliverMhParams:{
      get() {
        return this.checkAndSetPrimaryVal(this.options, "deliverMhParams", "deliverMhParams", false)
      },
      set(val) {
        this.$changeOptionsEV(val, "deliverMhParams", false)
      }
    },
    relativeComponentId: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "relativeComponentId", "relativeComponentId", null)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "relativeComponentId", false)
      }
    },
    filterStartDateFlag: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "filterStartDateFlag", "filterStartDateFlag", null)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "filterStartDateFlag", false)
      }
    },
    filterEndDateFlag: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "filterEndDateFlag", "filterEndDateFlag", null)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "filterEndDateFlag", false)
      }
    },
    startDateFlag: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "startDateFlag", "startDateFlag", null)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "startDateFlag", false)
      }
    },
    endDateFlag: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "endDateFlag", "endDateFlag", null)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "endDateFlag", false)
      }
    },
    relativeType: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "relativeType", "relativeType", "click")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "relativeType", false)
      }
    },
    activityTooltip: {
      get() {
        return this.options.activityTooltip || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activityTooltip", false)
      }
    },
    activityTooltipWidth: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "activityTooltipWidth", "activityTooltipWidth", 200)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activityTooltipWidth", false)
      }
    },
    activityTooltipHeight: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "activityTooltipHeight", "activityTooltipHeight", 200)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activityTooltipHeight", false)
      }
    },
    activityLineHeight: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "activityLineHeight", "activityLineHeight", 40)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activityLineHeight", false)
      }
    },
    tooltipTitleColor: {
      get() {
        return this.options.tooltipTitleColor || "rgba(255,255,255,1)"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "tooltipTitleColor", false)
      }
    },
    tooltipTitleFontFamily: {
      get() {
        return this.checkAndSetPrimaryVal(
          this.options,
          "tooltipTitleFontFamily",
          "tooltipTitleFontFamily",
          "sans-serif"
        )
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "tooltipTitleFontFamily", false)
      }
    },
    tooltipTitleFontSize: {
      get() {
        return this.options.tooltipTitleFontSize || 12
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "tooltipTitleFontSize", false)
      }
    },
    tooltipTitleFontWeight: {
      get() {
        return this.options.tooltipTitleFontWeight || 400
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "tooltipTitleFontWeight", false)
      }
    },
    contentHasLimit: {
      get() {
        return this.options.contentHasLimit || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "contentHasLimit", false)
      }
    },
    textLimitLines: {
      get() {
        return this.options.textLimitLines || 8
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textLimitLines", false)
      }
    },
    tooltipTimeColor: {
      get() {
        return this.options.tooltipTimeColor || "rgba(255,255,255,1)"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "tooltipTimeColor", false)
      }
    },
    tooltipTimeFontFamily: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "tooltipTimeFontFamily", "tooltipTimeFontFamily", "sans-serif")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "tooltipTimeFontFamily", false)
      }
    },
    tooltipTimeFontSize: {
      get() {
        return this.options.tooltipTimeFontSize || 12
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "tooltipTimeFontSize", false)
      }
    },
    tooltipTimeFontWeight: {
      get() {
        return this.options.tooltipTimeFontWeight || 400
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "tooltipTimeFontWeight", false)
      }
    },
    activityTooltipSpace: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "activityTooltipSpace", "activityTooltipSpace", 40)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activityTooltipSpace", false)
      }
    },
    activityTooltipBgColor: {
      get() {
        return this.options.activityTooltipBgColor || "#363B5D"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activityTooltipBgColor", false)
      }
    },
    activityTooltipBgIsThemeColor: {
      get() {
        return this.options.activityTooltipBgIsThemeColor || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activityTooltipBgIsThemeColor", false)
      }
    },

    tooltipBorderTypeFlag: {
      get() {
        return this.options.tooltipBorderTypeFlag
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "tooltipBorderTypeFlag", false)
      }
    },
    tooltipBorderRadius: {
      get() {
        return this.options.tooltipBorderRadius || 0
      },
      set(newVal) {
        if (this.tooltipBorderRadius === 2) {
          this.tooltipBorderTopLeftRadius = newVal
          this.tooltipBorderTopRightRadius = newVal
          this.tooltipBorderBottomLeftRadius = newVal
          this.tooltipBorderBottomRightRadius = newVal
        }
        this.$changeOptionsEV(newVal, "tooltipBorderRadius", false)
      }
    },
    tooltipBorderTopLeftRadius: {
      get() {
        return this.options.tooltipBorderTopLeftRadius || 0
      },
      set(newVal) {
        if (this.tooltipBorderTypeFlag === 2) {
          this.$changeOptionsEV(
            [parseInt(newVal), parseInt(newVal), parseInt(newVal), newVal],
            [
              "tooltipBorderTopRightRadius",
              "tooltipBorderBottomRightRadius",
              "tooltipBorderBottomLeftRadius",
              "tooltipBorderTopLeftRadius"
            ],
            false
          )
        } else {
          this.$changeOptionsEV(newVal, "tooltipBorderTopLeftRadius", false)
        }
      }
    },
    tooltipBorderTopRightRadius: {
      get() {
        return this.options.tooltipBorderTopRightRadius || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "tooltipBorderTopRightRadius", false)
      }
    },
    tooltipBorderBottomRightRadius: {
      get() {
        return this.options.tooltipBorderBottomRightRadius || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "tooltipBorderBottomRightRadius", false)
      }
    },
    tooltipBorderBottomLeftRadius: {
      get() {
        return this.options.tooltipBorderBottomLeftRadius || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "tooltipBorderBottomLeftRadius", false)
      }
    },
    tooltipBorderWidth: {
      get() {
        return this.options.tooltipBorderWidth || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "tooltipBorderWidth", false)
      }
    },
    tooltipBorderStyle: {
      get() {
        return this.options.tooltipBorderStyle || "solid"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "tooltipBorderStyle", false)
      }
    },
    tooltipBorderColor: {
      get() {
        return this.options.tooltipBorderColor || "transparent"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "tooltipBorderColor", false)
      }
    },
    tooltipBorderIsThemeColor: {
      get() {
        return this.options.tooltipBorderIsThemeColor || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "tooltipBorderIsThemeColor", false)
      }
    },
    tooltipBoxShadowColor: {
      get() {
        return this.options.tooltipBoxShadowColor || "transparent"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "tooltipBoxShadowColor", false)
      }
    },
    tooltipBoxShadowH: {
      get() {
        return this.options.tooltipBoxShadowH || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "tooltipBoxShadowH", false)
      }
    },
    tooltipBoxShadowV: {
      get() {
        return this.options.tooltipBoxShadowV || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "tooltipBoxShadowV", false)
      }
    },
    tooltipBoxShadowBlur: {
      get() {
        return this.options.tooltipBoxShadowBlur || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "tooltipBoxShadowBlur", false)
      }
    },
    tooltipBoxShadowSpread: {
      get() {
        return this.options.tooltipBoxShadowSpread || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "tooltipBoxShadowSpread", false)
      }
    },
    // 边距
    tooltipPaddingTypeFlag: {
      get() {
        let defaultType = 2
        if (
          ((this.tooltipPaddingTop === this.tooltipPaddingRight) === this.tooltipPaddingLeft) ===
          this.tooltipPaddingBottom
        ) {
          defaultType = 1
        }
        return this.options.tooltipPaddingTypeFlag || defaultType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "tooltipPaddingTypeFlag", false)
      }
    },
    tooltipPadding: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "tooltipPadding", "tooltipPadding", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "tooltipPadding", false)
      }
    },
    tooltipPaddingTop: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "tooltipPaddingTop", "tooltipPaddingTop", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "tooltipPaddingTop", false)
      }
    },
    tooltipPaddingRight: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "tooltipPaddingRight", "tooltipPaddingRight", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "tooltipPaddingRight", false)
      }
    },
    tooltipPaddingLeft: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "tooltipPaddingLeft", "tooltipPaddingLeft", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "tooltipPaddingLeft", false)
      }
    },
    tooltipPaddingBottom: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "tooltipPaddingBottom", "tooltipPaddingBottom", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "tooltipPaddingBottom", false)
      }
    }
  },
  methods: {
    // 高级设置
    highSet() {
      this.$API
        .updateAppAttr({
          param: {
            publicId: this.publicId,
            deliverMhParams: this.deliverMhParams
          }
        })
        .then(res => {
          if (res.data.code === 1) {
          }
        })
    },
    async getPublicId() {
      const { websiteId, pageId, wfwfid } = this.$store.state.states.getDataPageIds
      const rectAttr = this.getRectAttribute(this.ids)
      const appId = rectAttr?.options?.appId
      if (!appId) return
      const { restUrl } = await getAppointCacheData.call(this, pageId, wfwfid, websiteId, appId)
      this.publicId = restUrl.data.data.engineInstance.publicId
    },
    findComponent(type) {
    // 因为简单搜索组件也是自由布局组件，所以需要排除掉
      return this.$store.state[this.request_prefix].page.children[0].children.filter(rect => {
        return rect.shape === type && !rect.options?.pluginName?.includes("searchComponentPlugin")
      })[0]
    },
    getRelativeLists() {
      //  获取同一通栏内的其他组件
      const layout = this.$store.state[this.request_prefix].page.pageLayoutList
      const path = findCurrentComponentPathInLayoutByRectId(layout, this.ids.rect_id)
      let pageLayoutIds = findAllRects(layout[path[0]])
      this.relativeComponentLists = []
      if (pageLayoutIds.length > 0) {  //长度为1可能存在一个行布局内多个组件的情况
        for (let i = 0; i < pageLayoutIds.length; i++) {
          let item = this.getAttrById.call(this, this.$store.state[this.request_prefix], {
            container_id: this.ids.container_id,
            rect_id: pageLayoutIds[i]
          })
          if (item?.shape !== "cxCalendar") {
            //自动布局判断
            if(item.shape === "cxAutoLayout"){
              // 日历联动目前仅限自动布局一层结构，自动布局嵌套自动布局结构不支持使用
              if(item.elementOptions?.length > 0){
                for (let j = 0; j < item.elementOptions.length; j++) {
                  let item1 = item.elementOptions[j]
                  if (item1?.innerElement !== "cxCalendar") {
                    this.relativeComponentLists.push({
                      label: item1.name ? item1.name : item1.menuName,
                      value: pageLayoutIds[i] + "_autoLayout_" + item1.elementInAutoLayoutId
                    })
                  }
                }
              }
              else if(item.options?.elementOptions?.length > 0){
                //添加日历和图文列表不在同一自动布局下的情况
                for (let j = 0; j < item.options?.elementOptions.length; j++) {
                  let item1 = item.options?.elementOptions[j]
                  if (item1?.innerElement !== "cxCalendar") {
                    this.relativeComponentLists.push({
                      label: item1.name ? item1.name : item1.menuName,
                      value: pageLayoutIds[i] + "_autoLayout_" + item1.elementInAutoLayoutId
                    })
                  }
                }
              }
            }else{
              //日历组件
              this.relativeComponentLists.push({
                label: item.options.name ? item.options.name : item.options.menuName,
                value: pageLayoutIds[i]
              })
            }
          }
        }
      }
      if (this.relativeComponentId) {
        this.changeRelativeName()
      }
    },
    async changeRelativeName(val) {
      if (val) {
        this.relativeComponentId = typeof val === 'number' ? val.toString() : val
        this.options.startDateFlag = null
        this.options.endDateFlag = null
      }
      //改变关联的组件
      let rectAttr = this.getAttrById.call(this, this.$store.state[this.request_prefix], {
        container_id: this.ids.container_id,
        rect_id: this.relativeComponentId
      })
      let isAutoLayoutComp = false, elementInAutoLayoutId1 = null, idsArr = []
      if(!rectAttr && ((val && val.indexOf("_autoLayout_") > -1) || (this.relativeComponentId &&
        this.relativeComponentId.indexOf("_autoLayout_") > -1))){
        isAutoLayoutComp = true
        idsArr = val ? val.split("_autoLayout_") : this.relativeComponentId.split("_autoLayout_")
        elementInAutoLayoutId1 = Number(idsArr[1])
        rectAttr = this.getAttrById.call(this, this.$store.state[this.request_prefix], {
          container_id: this.ids.container_id,
          rect_id: Number(idsArr[0]),
          elementInAutoLayoutId: Number(idsArr[1]),
          path: undefined
        })
      }
      if (rectAttr?.options?.noCacheComponent || (isAutoLayoutComp && rectAttr?.noCacheComponent)) {
        const { cacheDataTypes, restDataUrl } = await this.getAppointDataEv(rectAttr, isAutoLayoutComp)
        let { activeIndex } = !isAutoLayoutComp ? rectAttr.options : rectAttr
        const updateLayoutData = new UpdateLayoutData(this)
        let ids1 = {
          container_id: this.ids.container_id,
          rect_id: this.relativeComponentId
        }
        if(isAutoLayoutComp){
          ids1.rect_id =  Number(idsArr[0]),
          ids1.elementInAutoLayoutId = elementInAutoLayoutId1
        }
        const { completeData } = await updateLayoutData.upDateRect({
          activeIndex,
          rectAttr,
          cacheDataTypes,
          restDataUrl,
          ids: ids1,
          categoryMode: rectAttr?.options?.categoryMode
        })
        //获取匹配信息
        this.flagLists = []
        if (completeData.length > 0) {
          for (let j in completeData[0]) {
            if (completeData[0][j].key) {
              this.flagLists.push({
                value: j,
                label: completeData[0][j].key
              })
            }
          }
        }
      }
    },
    async getAppointDataEv(rectAttr, isAutoLayoutComp) {
      const { websiteId, pageId, wfwfid } = this.$store.state.states.getDataPageIds
      let rectAttr1 = rectAttr.options
      if(isAutoLayoutComp){
        rectAttr1 = rectAttr
      }
      const appId = rectAttr1.appId ? rectAttr1.appId : rectAttr1.myFetchParam.appId
      return await getAppointCacheData.call(
        this,
        pageId,
        wfwfid,
        websiteId,
        appId,
        { useSubPageQuery: rectAttr1.useSubPageQuery, selectedDetailParam: rectAttr1.selectedDetailParam }
      )
    },
    async getFields(rectAttr) {
      const { cacheDataTypes, restDataUrl } = await this.getAppointDataEv(rectAttr, false)
        let { activeIndex } = rectAttr.options
        const updateLayoutData = new UpdateLayoutData(this)
        let ids1 = {
          container_id: rectAttr.container_id,
          rect_id: rectAttr.rect_id
        }
        const { completeData } = await updateLayoutData.upDateRect({
          activeIndex,
          rectAttr,
          cacheDataTypes,
          restDataUrl,
          ids: ids1,
          categoryMode: rectAttr?.options?.categoryMode
        })
        //获取匹配信息
        this.filterFlagLists = []
        if (completeData.length > 0) {
          for (let j in completeData[0]) {
            if (completeData[0][j].key) {
              this.filterFlagLists.push({
                value: j,
                label: completeData[0][j].key
              })
            }
          }
        }
    },
    async getFieldsNew() {
        const completeData = JSON.parse(window.localStorage.getItem("completeData"))
        //获取匹配信息
        this.filterFlagLists = []
        if (completeData.length > 0) {
          for (let j in completeData[0]) {
            if (completeData[0][j].key) {
              this.filterFlagLists.push({
                value: j,
                label: completeData[0][j].key
              })
            }
          }
        }
    },

    getFocus(event) {
      event.currentTarget.select()
    },
    addBoxshadow() {
      if (!Array.isArray(this.tooltipBoxShadowH)) {
        this.tooltipBoxShadowH = [this.tooltipBoxShadowH]
        this.tooltipBoxShadowV = [this.tooltipBoxShadowV]
        this.tooltipBoxShadowBlur = [this.tooltipBoxShadowBlur]
        this.tooltipBoxShadowSpread = [this.tooltipBoxShadowSpread]
        this.tooltipBoxShadowColor = [this.tooltipBoxShadowColor]
      }
      let tooltipBoxShadowH = JSON.parse(JSON.stringify(this.tooltipBoxShadowH))
      let tooltipBoxShadowV = JSON.parse(JSON.stringify(this.tooltipBoxShadowV))
      let tooltipBoxShadowBlur = JSON.parse(JSON.stringify(this.tooltipBoxShadowBlur))
      let tooltipBoxShadowSpread = JSON.parse(JSON.stringify(this.tooltipBoxShadowSpread))
      let tooltipBoxShadowColor = JSON.parse(JSON.stringify(this.tooltipBoxShadowColor))
      tooltipBoxShadowH.push(0)
      tooltipBoxShadowV.push(4)
      tooltipBoxShadowBlur.push(4)
      tooltipBoxShadowSpread.push(0)
      tooltipBoxShadowColor.push("rgba(0,0,0,0.25)")
      this.tooltipBoxShadowH = tooltipBoxShadowH
      this.tooltipBoxShadowV = tooltipBoxShadowV
      this.tooltipBoxShadowBlur = tooltipBoxShadowBlur
      this.tooltipBoxShadowSpread = tooltipBoxShadowSpread
      this.tooltipBoxShadowColor = tooltipBoxShadowColor
    }
  }
})
</script>

<style scoped>
.select_flag_div {
  border: 1px solid #e9e9e9;
  padding: 0 10px 10px;
  background-color: #fbfcfd;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
}
.type-change-item ::v-deep .el-tabs__content {
  display: none;
}
.type-change-item ::v-deep .el-tabs__item.is-active {
  color: var(--themeColor);
  font-weight: normal;
}
</style>
